import {
	GET_PLANTAS_REQUEST,
	GET_PLANTAS_RESPONSE,
	GET_PLANTAS_FAILURE,
	GET_DATA_GRAPHIC_HOME_REQUEST,
	GET_DATA_GRAPHIC_HOME_RESPONSE,
	GET_DATA_GRAPHIC_HOME_FAILURE,
	GET_OCUPACION_PATIOS_INICIAL_REQUEST,
	GET_OCUPACION_PATIOS_INICIAL_RESPONSE,
	GET_OCUPACION_PATIOS_INICIAL_FAILURE,
	GET_OCUPACION_PATIOS_FILTER_REQUEST,
	GET_OCUPACION_PATIOS_FILTER_RESPONSE,
	GET_OCUPACION_PATIOS_FILTER_FAILURE,
	GET_OCUPACION_DETALLE_REQUEST,
	GET_OCUPACION_DETALLE_RESPONSE,
	GET_OCUPACION_DETALLE_FAILURE,
	GET_BLOQUERAS_ANTERIOR_REQUEST,
	GET_BLOQUERAS_ANTERIOR_RESPONSE,
	GET_BLOQUERAS_ANTERIOR_FAILURE,
	GET_TUBOS_ANTERIOR_REQUEST,
	GET_TUBOS_ANTERIOR_RESPONSE,
	GET_TUBOS_ANTERIOR_FAILURE,
	GET_AGREGADOS_ANTERIOR_REQUEST,
	GET_AGREGADOS_ANTERIOR_RESPONSE,
	GET_AGREGADOS_ANTERIOR_FAILURE,
	GET_PRODUCCION_REQUEST,
	GET_PRODUCCION_RESPONSE,
	GET_PRODUCCION_FAILURE,
	GET_PRODUCCION_GRAPHIC_REQUEST,
	GET_PRODUCCION_GRAPHIC_RESPONSE,
	GET_PRODUCCION_GRAPHIC_FAILURE,
	GET_EXISTENCIA_ACTUAL_REQUEST,
	GET_EXISTENCIA_ACTUAL_RESPONSE,
	GET_EXISTENCIA_ACTUAL_FAILURE,
	GET_DESPACHOS_DIARIOS_GRAPHIC_REQUEST,
	GET_DESPACHOS_DIARIOS_GRAPHIC_RESPONSE,
	GET_DESPACHOS_DIARIOS_GRAPHIC_FAILURE,
	GET_DESPACHOS_DIARIOS_TABLE_REQUEST,
	GET_DESPACHOS_DIARIOS_TABLE_RESPONSE,
	GET_DESPACHOS_DIARIOS_TABLE_FAILURE,
	GET_DESPACHOS_DIARIOS_DETALLADO_REQUEST,
	GET_DESPACHOS_DIARIOS_DETALLADO_RESPONSE,
	GET_DESPACHOS_DIARIOS_DETALLADO_FAILURE,
	GET_FAMILIA_PLANTAS_REQUEST,
	GET_FAMILIA_PLANTAS_RESPONSE,
	GET_FAMILIA_PLANTAS_FAILURE
} from './actions';

const data_get_plantas_InitialState = {
	get_plantas: [],
	error: null,
	isLoading: false
};
export const get_plantas = (state = data_get_plantas_InitialState, action) => {
	switch (action.type) {
		case GET_PLANTAS_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_PLANTAS_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				get_plantas: action.get_plantas
			};
		case GET_PLANTAS_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const data_get_familia_plantas_InitialState = {
	get_familia: [],
	error: null,
	isLoading: false
};
export const get_familia = (state = data_get_familia_plantas_InitialState, action) => {
	switch (action.type) {
		case GET_FAMILIA_PLANTAS_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_FAMILIA_PLANTAS_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				get_familia: action.get_familia
			};
		case GET_FAMILIA_PLANTAS_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const data_get_home_graphic_InitialState = {
	data_graphic: [],
	error: null,
	isLoading: false
};
export const data_graphic = (state = data_get_home_graphic_InitialState, action) => {
	switch (action.type) {
		case GET_DATA_GRAPHIC_HOME_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_DATA_GRAPHIC_HOME_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				data_graphic: action.data_graphic
			};
		case GET_DATA_GRAPHIC_HOME_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const OcupacionPatiosIniInitialState = {
	data_ocuPatIni: [],
	error: null,
	isLoading: false
};
export const data_ocuPatIni = (state = OcupacionPatiosIniInitialState, action) => {
	switch (action.type) {
		case GET_OCUPACION_PATIOS_INICIAL_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_OCUPACION_PATIOS_INICIAL_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				data_ocuPatIni: action.data_ocuPatIni
			};
		case GET_OCUPACION_PATIOS_INICIAL_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const OcupacionPatiosFilterInitialState = {
	data_ocuPatFilter: [],
	error: null,
	isLoading: false
};
export const data_ocuPatFilter = (state = OcupacionPatiosFilterInitialState, action) => {
	switch (action.type) {
		case GET_OCUPACION_PATIOS_FILTER_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_OCUPACION_PATIOS_FILTER_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				data_ocuPatFilter: action.data_ocuPatFilter
			};
		case GET_OCUPACION_PATIOS_FILTER_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const OcupacionPatiosDetalleInitialState = {
	data_ocupacion_detalle: [],
	error: null,
	isLoading: false
};
export const data_ocupacion_detalle = (state = OcupacionPatiosDetalleInitialState, action) => {
	switch (action.type) {
		case GET_OCUPACION_DETALLE_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_OCUPACION_DETALLE_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				data_ocupacion_detalle: action.data_ocupacion_detalle
			};
		case GET_OCUPACION_DETALLE_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const Bloq_anteriorInitialState = {
	data_bloq_anterior: [],
	error: null,
	isLoading: false
};
export const data_bloq_anterior = (state = Bloq_anteriorInitialState, action) => {
	switch (action.type) {
		case GET_BLOQUERAS_ANTERIOR_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_BLOQUERAS_ANTERIOR_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				data_bloq_anterior: action.data_bloq_anterior
			};
		case GET_BLOQUERAS_ANTERIOR_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const Tubos_anteriorInitialState = {
	data_tubos_anterior: [],
	error: null,
	isLoading: false
};
export const data_tubos_anterior = (state = Tubos_anteriorInitialState, action) => {
	switch (action.type) {
		case GET_TUBOS_ANTERIOR_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_TUBOS_ANTERIOR_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				data_tubos_anterior: action.data_tubos_anterior
			};
		case GET_TUBOS_ANTERIOR_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const Agregados_anteriorInitialState = {
	data_agregados_anterior: [],
	error: null,
	isLoading: false
};
export const data_agregados_anterior = (state = Agregados_anteriorInitialState, action) => {
	switch (action.type) {
		case GET_AGREGADOS_ANTERIOR_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_AGREGADOS_ANTERIOR_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				data_agregados_anterior: action.data_agregados_anterior
			};
		case GET_AGREGADOS_ANTERIOR_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const produccion_InitialState = {
	produccion: [],
	error: null,
	isLoading: false
};
export const produccion = (state = produccion_InitialState, action) => {
	switch (action.type) {
		case GET_PRODUCCION_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_PRODUCCION_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				produccion: action.produccion
			};
		case GET_PRODUCCION_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const produccion_graphic_InitialState = {
	produccion_graphic: [],
	error: null,
	isLoading: false
};
export const produccion_graphic = (state = produccion_graphic_InitialState, action) => {
	switch (action.type) {
		case GET_PRODUCCION_GRAPHIC_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_PRODUCCION_GRAPHIC_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				produccion_graphic: action.produccion_graphic
			};
		case GET_PRODUCCION_GRAPHIC_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const existencia_actual_InitialState = {
	existencia_A: [],
	error: null,
	isLoading: false
};
export const existencia_A = (state = existencia_actual_InitialState, action) => {
	switch (action.type) {
		case GET_EXISTENCIA_ACTUAL_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_EXISTENCIA_ACTUAL_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				existencia_A: action.existencia_A
			};
		case GET_EXISTENCIA_ACTUAL_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const despachos_diarios_graphic_InitialState = {
	despachos_diarios_g: [],
	error: null,
	isLoading: false
};
export const despachos_diarios_g = (state = despachos_diarios_graphic_InitialState, action) => {
	switch (action.type) {
		case GET_DESPACHOS_DIARIOS_GRAPHIC_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_DESPACHOS_DIARIOS_GRAPHIC_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				despachos_diarios_g: action.despachos_diarios_g
			};
		case GET_DESPACHOS_DIARIOS_GRAPHIC_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const despachos_diarios_table_InitialState = {
	despachos_diarios_t: [],
	error: null,
	isLoading: false
};
export const despachos_diarios_t = (state = despachos_diarios_table_InitialState, action) => {
	switch (action.type) {
		case GET_DESPACHOS_DIARIOS_TABLE_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_DESPACHOS_DIARIOS_TABLE_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				despachos_diarios_t: action.despachos_diarios_t
			};
		case GET_DESPACHOS_DIARIOS_TABLE_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const despachos_diarios_detallado_InitialState = {
	despachos_diarios_d: [],
	error: null,
	isLoading: false
};
export const despachos_diarios_d = (state = despachos_diarios_detallado_InitialState, action) => {
	switch (action.type) {
		case GET_DESPACHOS_DIARIOS_DETALLADO_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case GET_DESPACHOS_DIARIOS_DETALLADO_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				despachos_diarios_d: action.despachos_diarios_d
			};
		case GET_DESPACHOS_DIARIOS_DETALLADO_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};
